import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalPositionService } from '../../../services/modal-position.service'
import { CreateNewWorkspaceModalComponent } from './create-new-workspace-modal.component'

export enum CreateNewWorkspaceModalAction {
  SAVE,
  SAVE_AND_ACTIVATE,
}
export interface CreateNewWorkspaceModalResponse {
  name: string
  description: string
  action: CreateNewWorkspaceModalAction
}

@Injectable()
export class CreateNewWorkspaceModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  toggle(
    name: string,
    description: string,
  ): Promise<CreateNewWorkspaceModalResponse> {
    const compKey = 'create-new-workspace'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(CreateNewWorkspaceModalComponent, {
      size: 'md',
      keyboard: false,
      windowClass: uniqueId,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })
    const component =
      modalRef.componentInstance as CreateNewWorkspaceModalComponent
    component.name = name
    component.description = description
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modalRef.result
  }
}
